import _ajax from './ajax';
import { useTestApi, isTestHost, isEnvTest } from '@/config/env'

// ============================================================================
// 域名 / 环境配置
// ============================================================================

// 静态资源 CDN
const CDN_POSTER = 'https://poster.xdcdn.net'
const CDN_WEBSITE = 'https://website.xdcdn.net'

// 主接口 / 报名活动接口的正式 & 测试地址
const API_MAIN_PROD = 'https://match-sausage.xd.cn'
const API_MAIN_TEST = 'http://39.107.229.24:22102'
const API_APPLY_PROD = 'https://poster-api.xd.cn/api/v1.0/activity/match'
const API_APPLY_TEST = 'http://39.107.229.24:13009/api/v1.0/activity/match'

// 初始域名: env.js 里的静态 useTestApi (URL ?env=test + host 白名单双重满足)
// 运行时可通过 applyApiEnvFromConfig(config) 覆盖: config.test_api_env true → 正式, false → 测试
let domain = useTestApi ? API_MAIN_TEST : API_MAIN_PROD
let new_pre = useTestApi ? API_APPLY_TEST : API_APPLY_PROD

// config.test_api_env: 仅 isTestHost 生效, 用于测试环境统一切 API 后端
//   true  → 走正式 (调试线上数据)
//   false → 走测试 (联调新接口)
//   缺省/其他值 → 保持静态判断
// 消费方通过 loadAppConfig 在 config 拉取成功后调用, 后续 API 通过闭包引用 domain/new_pre 拿到最新值
export function applyApiEnvFromConfig(config) {
  if (!isTestHost) return
  // URL ?env=test 已明确指定测试 API, config 不覆盖 (URL > config, 保持个人调试意图, 对齐 ?stage 优先级)
  if (isEnvTest) return
  const raw = config?.test_api_env
  if (raw === true) {
    domain = API_MAIN_PROD
    new_pre = API_APPLY_PROD
  } else if (raw === false) {
    domain = API_MAIN_TEST
    new_pre = API_APPLY_TEST
  }
}

// ============================================================================
// 公共
// ============================================================================

// 获取服务器时间
const reqcurrentTime = () => _ajax(domain + '/api/v2.0/match/common/time')

// 获取赛事中心静态配置
const reqConfig = () => _ajax(`${CDN_POSTER}/xindong/form/58881.all/website/sausage/match/config.json`, {t: new Date().getTime()})

// 获取赛事规则
const reqRule = () => _ajax(`${CDN_WEBSITE}/module/sausage-match/rule.json`)

// ============================================================================
// 直播
// ============================================================================

// 获取直播间地址
const reqVideoLink = () => _ajax(domain + '/api/get_live_url')

// 获取直播信息
const getVideo = link => _ajax(link);

// ============================================================================
// 赛季 & 赛程
// ============================================================================

// 简易赛季列表
const reqMatchSimpleSeasons = data => _ajax(domain + '/api/v2.0/match/simple-seasons', data)

// 获取所有赛程, 以及每个赛程划分的阶段
const reqArrangeSeasons = data => _ajax(domain + '/api/v2.0/match/seasons', data)

// 获取队伍列表
const reqTeamsList = data => _ajax(domain + '/api/v2.0/match/team-list', data)

// 获取队伍信息
const reqTeamInfo = data => _ajax(domain + '/api/v2.0/match/team', data)

// 获取赛程参赛队伍
const reqScheduleTeams = data => _ajax(domain + '/api/v2.0/match/team-list-by-schedule', data)

// 获取赛程战局队列
const reqMatchList = data => _ajax(domain + '/api/v2.0/match/match-list', data)

// 获取比赛成绩
const reqMatchDetail = data => _ajax(domain + '/api/v2.0/match/team-score', data)

// ============================================================================
// 用户
// ============================================================================

// 获取用户赛事币信息
const reqUserInfo = (data) => _ajax(domain + '/api/v2.0/match/user/info', data)

// 关注 / 取消关注
const reqFocusStatus = (token, data) => _ajax(domain + `/api/v2.0/match/user/follow?token=${token}`, data, 'POST')

// 上报观看时长
const reportMinutes = (token,data) => _ajax(domain + `/api/v2.0/match/user/report-minutes?token=${token}`, data, 'POST')

// 更新玩家头像
const updateUserAvatar = (token,data) => _ajax(domain + `/api/v2.0/match/user/update-avatar?token=${token}`, data,'POST')

// 红点状态
const getRedDotState = (data) => _ajax(domain + '/api/v2.0/match/user/red-dot-show',data)

// 领取每日赛事币 (废弃)
const receiveGold = (token, data) => _ajax(domain + `/api/v2.0/match/user/receive-gold?token=${token}`, data, 'POST')

// ============================================================================
// 竞猜
// ============================================================================

// 获取竞猜赛程列表
const reqScheduleList = data => _ajax(domain + '/api/v2.0/match/quiz/schedule-list', data)

// 获取竞猜信息
const reqQuestionList = data => _ajax(domain + '/api/v2.0/match/quiz/list', data)

// 获取在竞猜期间的实时竞猜内容
const reqQuizListLive = () => _ajax('/api/quiz_list_live')

// 实时竞猜
const realTimeGuessing = (token) => _ajax(domain + '/api/v2.0/match/quiz/current-question',{token})

// 竞猜投注
const submitQuiz = (token, data) => _ajax(domain + `/api/v2.0/match/quiz/submit?token=${token}`, data, 'POST')

// 竞猜记录
const reqQuizList = data => _ajax(domain + '/api/v2.0/match/quiz/record', data)

// ============================================================================
// 商城 & 兑换
// ============================================================================

// 获取商品列表
const reqGoodsList = data => _ajax(domain + '/api/v2.0/match/exchange/list', data)

// 提交兑换
const submitExchange = (token, data) => _ajax(domain + `/api/v2.0/match/exchange/submit?token=${token}`, data, 'POST')

// 兑换历史
const reqStoreHistory = data => _ajax(domain + '/api/v2.0/match/exchange/record', data)

// ============================================================================
// 礼物 & 送礼
// ============================================================================

// 获取礼物列表 / 背包数据
const reqGiftList = (data) => _ajax(domain + '/api/v2.0/match/gift/list',data)

// 赠送礼物
const presentGift = (token,data) => _ajax(domain + `/api/v2.0/match/gift/send?token=${token}`, data,'POST')

// 直接送礼物 (不消耗背包)
const directPresentGift = (token,data) => _ajax(domain + `/api/v2.0/match/gift/direct?token=${token}`, data,'POST')

// 礼物兑换
const getBuying = (token,data) => _ajax(domain + `/api/v2.0/match/gift/exchange?token=${token}`,data,'POST')

// 助威列表
const getCheerForList = data => _ajax(domain + '/api/v2.0/match/gift/team-list',data)

// ============================================================================
// 排行榜
// ============================================================================

// 战队排行榜 (总)
const getTeamRanking = data => _ajax(domain + '/api/v2.0/match/gift/team-total-rank',data)

// 个人总排行榜
const getPersonalRanking = token => _ajax(domain + `/api/v2.0/match/gift/person-rank?token=${token}`)

// 战队排行榜 (详细)
const getGiftTeamList = token => _ajax(domain + `/api/v2.0/match/gift/team-rank?token=${token}`)

// 战队详情榜
const getGiftTeamDetail = (data) => _ajax(domain + '/api/v2.0/match/gift/team-supporter',data)

// 战队个人送礼 (按战队取排行值, 当前无调用方, 预留接口)
const getRankValueByTeam = (data) => _ajax(domain + '/api/v2.0/match/gift/rank-value',data);

// 个人送礼
const userPersonalRankValue = (data) => _ajax(domain + '/api/v2.0/match/gift/personal-rank-value',data);

// ============================================================================
// 任务 & 活动
// ============================================================================

// 获取活动列表
const getActivityList = (data) => _ajax(domain + '/api/v2.0/match/task/list',data)

// 领取活动奖励
const getActivityReward = (token,data) => _ajax(domain + `/api/v2.0/match/task/receive?token=${token}`,data,'POST')

// 每日任务
const getTaskList = (token) => _ajax(domain + `/api/v2.0/match/task/daily-list?token=${token}`)

// ============================================================================
// 名人堂
// ============================================================================

// 获取名人堂列表
const reqStarList = data => _ajax(domain + '/api/v2.0/match/star-member-list', data)

// 个人五边形数据
const reqStarInfo = data => _ajax(domain + '/api/v2.0/match/member-detail', data)

// ============================================================================
// 报名 (走 API_APPLY 域名)
// ============================================================================

// 提交报名
const submitApply = (token, data) => _ajax(`${new_pre}/submit?token=${token}`, data, 'POST');

// 同意报名须知
const agreeNotice = token => _ajax(`${new_pre}/agree?token=${token}`, {}, 'POST');

// 报名状态
const reqApplyInfo = data => _ajax(`${new_pre}/status`, data);

// 修改昵称
const reqNick = data => _ajax(`${new_pre}/nick`, data);

// ============================================================================
// 奖金 (独立服务, 仅正式环境, 无测试机)
// ============================================================================

// 获取奖金
const reqPrize = () => _ajax('https://poster-api.xd.cn/api/v1.0/reserve/sausage-amount')

// ============================================================================
// 导出
// ============================================================================

export {
    // 公共
    reqcurrentTime,
    reqConfig,
    reqRule,
    // 直播
    reqVideoLink,
    getVideo,
    // 赛季 & 赛程
    reqMatchSimpleSeasons,
    reqArrangeSeasons,
    reqTeamsList,
    reqTeamInfo,
    reqScheduleTeams,
    reqMatchList,
    reqMatchDetail,
    // 用户
    reqUserInfo,
    reqFocusStatus,
    reportMinutes,
    updateUserAvatar,
    getRedDotState,
    receiveGold,
    // 竞猜
    reqScheduleList,
    reqQuestionList,
    reqQuizListLive,
    realTimeGuessing,
    submitQuiz,
    reqQuizList,
    // 商城 & 兑换
    reqGoodsList,
    submitExchange,
    reqStoreHistory,
    // 礼物 & 送礼
    reqGiftList,
    presentGift,
    directPresentGift,
    getBuying,
    getCheerForList,
    // 排行榜
    getTeamRanking,
    getPersonalRanking,
    getGiftTeamList,
    getGiftTeamDetail,
    getRankValueByTeam,
    userPersonalRankValue,
    // 任务 & 活动
    getActivityList,
    getActivityReward,
    getTaskList,
    // 名人堂
    reqStarList,
    reqStarInfo,
    // 报名
    submitApply,
    agreeNotice,
    reqApplyInfo,
    reqNick,
    // 奖金
    reqPrize,
}
